import type { TFunction } from 'i18next';
import type { AudienceForm } from '../types';

export const getExportTargetLabels = (t: TFunction) => {
  return {
    cookie: t('Cookies'),
    ctv: t('CTV'),
    device: t('MAIDs'),
    id5: t('ID5'),
    ip: t('IP Address'),
    idl: t('RampID'),
  } satisfies Record<keyof AudienceForm['export_targets'], string>;
};
